import axios from 'axios';
import authService from './authService';
import router from '@/router';
import { API_URL } from '@/config/api';

const api = axios.create({ baseURL: API_URL, timeout: 20000 });

api.interceptors.request.use((config) => {
  const token = authService.token.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
}, (error) => Promise.reject(error));

api.interceptors.response.use((r) => r, (error) => {
  if (error.response?.status === 401) {
    const requiresAuth = router.currentRoute.matched.some((record) => record.meta.requiresAuth === true);
    if (requiresAuth) authService.logout();
  }
  return Promise.reject(error);
});

const base = '/casa';
const id = (aparelhoId) => encodeURIComponent(aparelhoId);

/** Mensagem pt-BR de um erro da casa ({erro} do servidor) ou genérica. */
export function mensagemErro(error, padrao = 'Não foi possível falar com a casa.') {
  return error?.response?.data?.erro || padrao;
}

export default {
  /** Câmeras: estado do portão e alerta. */
  portao() { return api.get(`${base}/cameras/portao`).then((r) => r.data); },
  silenciarPortao() { return api.post(`${base}/cameras/portao/silenciar`, {}, { timeout: 30000 }).then((r) => r.data); },
  definirAlertaPortao(ligado) { return api.put(`${base}/cameras/portao/ligado`, { ligado }, { timeout: 30000 }).then((r) => r.data); },
  avisosPortao(depois) {
    return api.get(`${base}/cameras/avisos`, { params: depois === undefined ? {} : { depois } }).then((r) => r.data);
  },
  videoToken() { return api.get(`${base}/cameras/video-token`).then((r) => r.data); },
  temAcesso() {
    return api.get(`${base}/acesso`).then(() => true).catch(() => false);
  },
  aparelhos() { return api.get(`${base}/aparelhos`).then((r) => r.data.aparelhos); },
  aparelho(aparelhoId) { return api.get(`${base}/aparelhos/${id(aparelhoId)}`).then((r) => r.data); },
  comandar(aparelhoId, chave, valor) {
    return api.post(`${base}/aparelhos/${id(aparelhoId)}/comando`, { chave, valor }).then((r) => r.data);
  },
  editar(aparelhoId, dados) { return api.patch(`${base}/aparelhos/${id(aparelhoId)}`, dados).then((r) => r.data); },
  /** Cômodos que o robô conhece ([{id, nome}], em ordem de nome). */
  comodos(aparelhoId) { return api.get(`${base}/aparelhos/${id(aparelhoId)}/comodos`).then((r) => r.data.comodos || []); },
  renomearComodo(aparelhoId, n, nome) {
    return api.put(`${base}/aparelhos/${id(aparelhoId)}/comodos/${encodeURIComponent(n)}`, { nome })
      .then((r) => r.data.comodos || []);
  },
  limparComodos(aparelhoId, ids, passadas) {
    return api.post(`${base}/aparelhos/${id(aparelhoId)}/limpar-comodos`, { comodos: ids, passadas }).then((r) => r.data);
  },
  integracoes() { return api.get(`${base}/integracoes`).then((r) => r.data); },
  energia(mes) { return api.get(`${base}/energia`, { params: mes ? { mes } : {} }).then((r) => r.data); },
  config() { return api.get(`${base}/config`).then((r) => r.data); },
  definirTarifa(tarifa) { return api.patch(`${base}/config`, { tarifa_kwh: tarifa }).then((r) => r.data); },
  iniciarSmartThings() { return api.post(`${base}/auth/smartthings/iniciar`).then((r) => r.data.url); },
  concluirSmartThings(urlRetorno) {
    return api.post(`${base}/auth/smartthings/concluir`, { url_retorno: urlRetorno }).then((r) => r.data);
  },
};
